import { useHiddenTabBar } from "@greeter/matter";
import { UpdateUserPageApiHandler } from "./UpdateUserPageApiHandler";

export const UpdateUserRouteHandler: React.FC = () => {
  useHiddenTabBar();

  return <UpdateUserPageApiHandler />;
};
